import React from 'react';
import {Helmet} from "react-helmet";
import TermsContent from "./TermsContent";

/** Publiczna strona z regulaminem. Dostępna bez logowania. */
const Terms = () => <>
  <Helmet>
    <title>Regulamin</title>
  </Helmet>
  <div className="legal-page legal-document">
    <TermsContent/>
  </div>
</>;

Terms.url = '/terms';

export default Terms;
